<template lang='pug'>
//- PopBox-Main
div.cancell-popbox(:class='$style[`cc-popbox`]')
  div(:class='[$style[`cc-popbox-block`], $style[isLargeHeight ? `large-height` : ``]]')

    .custom-scrollbar(:class='$style[`cc-popbox-wrap`]')
      //- 註冊確認訊息區塊
      PopLoading(v-if='popBoxStatus.include === `loading`' :textInfo='`請稍等..`')
      //- 翻譯 / 健檢分析
      PopProgressLoading(v-else-if='popProgressStatus.active' :feature='popProgressStatus.feature')
      //- 血糖血壓上傳
      PopGlucosePressureUploader(v-else-if='popBloodUploadStatus.active' :feature='popBloodUploadStatus.feature')
      //- 閱讀隱私政策與使用條款
      PopReadAgreement(v-else-if='popBoxStatus.include === `readAgreement`')
      //- 會員資料確認更新訊息區塊
      PopCheer(v-else-if='popBoxStatus.include === `checkListAchieve`' :textInfo='`目標達成，太棒了!`')
      //- 登入成功訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `loginConfirm`' :textInfo='`登入成功!`')
      //- 註冊確認訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `registerConfirm`' :textInfo='`註冊成功!`')
      //- 會員故事卡確認創建訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `createConfirm`' :textInfo='`建立成功!`')
      //- 會員資料確認更新訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `updateConfirm`' :textInfo='`儲存更新完成!`')
      //- 加入購物成功
      PopConfirm(v-else-if='popBoxStatus.include === `addCartConfirm`' :textInfo='`加入購物完成!`')
      //- 確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `resetConfirm`' :textInfo='`已發送至信箱!`')
      //- 驗證密碼確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `sendVerified`' :textInfo='`驗證信已發送至信箱!`')
      //- 通用刪除
      PopConfirm(v-else-if='popBoxStatus.include === `sendDelete`' :textInfo='`刪除成功!`')
      //- 訂閱成功
      PopConfirm(v-else-if='popBoxStatus.include === `subscribeConfirm`' :textInfo='`訂閱成功!`')
      //- 追蹤醫師確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `followConfirm`' :textInfo='`追蹤成功!`')
      //- 建立提問確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `sendConfirm`' :textInfo='`送出成功!`')
      //- 建立提問確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `eproCreateConfirm`' :textInfo='`已完成紀錄!`')
      //- 建立提問確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `resetPasswordConfirm`' :textInfo='`已重設新密碼!`')
      //- 建立Bind開通綁定
      PopConfirm(v-else-if='popBoxStatus.include === `sendBindConfirm`' :textInfo='`開通成功!`')
      //- 建立ePRO加入綁定
      PopConfirm(v-else-if='popBoxStatus.include === `sendJoinConfirm`' :textInfo='`完成加入!`')
      //- 建立提問確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `sendConfirmFreeVip`' :textInfo='`已啟用免費VIP訂閱`')
      //- 建立提問確認送出訊息區塊
      PopConfirm(v-else-if='popBoxStatus.include === `sendChatAdditional`' :textInfo='`已傳送至聊天室`')
      //- AI Solution回饋
      PopConfirm(v-else-if='popBoxStatus.include === `sendEvaluate`' :textInfo='`感謝您的回饋!`')
      //- 重設密碼信箱發送通知
      PopConfirm(v-else-if='popBoxStatus.include === `sendResetPasswordEmail`' :textInfo='`已發送重設連結!`')
      //- 提醒建立病歷資料訊息區塊
      PopCreatePersonalData(v-else-if='popBoxStatus.include === `createPersonalData`')
      //- 會員登入區塊
      PopLogin(v-else-if='popBoxStatus.include === `login`')
      //- 太久未登入 重新登入提示區塊
      PopRelogin(v-else-if='popBoxStatus.include === `relogin`')
      //- 要求帳號認證
      PopNeedVerify(v-else-if='popBoxStatus.include === `needVerify`')
      //- 大頭貼上傳提示區塊
      PopAvatarUploader(v-else-if='popBoxStatus.include === `avatarUpload`')
      //- 線上諮詢上傳提示區塊
      PopChatUploader(v-else-if='popBoxStatus.include === `fileChatUpload`')
      //- 線上諮詢語音輸入
      PopSpeechInputer(v-else-if='popBoxStatus.include === `speechInput`')
      //- Dr.Cell AI智能小幫手
      PopChatWizard(v-else-if='popBoxStatus.include === `chatWizard`')
      //- 新增癌友故事卡
      PopControlResume(v-else-if='popBoxStatus.include === `createResume`' :feature='`create`')
      //- 編輯癌友故事卡
      PopControlResume(v-else-if='popBoxStatus.include === `updateResume`' :feature='`update`')
      //- 故事卡已存在
      PopResumeExist(v-else-if='popBoxStatus.include === `existResume`')
      //- 啟用 ePRO 遠距照護服務
      PopWarning(v-else-if='popBoxStatus.include === `warnNoEcard`' :textInfo='`請先啟用 ePRO 遠距照護服務`')
      //-無法辨識的內容
      PopWarning(v-else-if='popBoxStatus.include === `warnUnrecognized`' :textInfo='`抱歉，非正確的內容或無法辨識`')
      //-無法辨識的內容
      PopWarning(v-else-if='popBoxStatus.include === `warnUnrecognizedAlert`' :textInfo='`圖片辨識困難無法準確分析，請提供更清晰的圖片。`')
      //- C幣不足
      PopWarning(v-else-if='popBoxStatus.include === `warnLackCoin`' :textInfo='`您的C幣不足！`')
      //- C幣兌換商品
      PopWarning(v-else-if='popBoxStatus.include === `warnNotCoin`' :textInfo='`抱歉！加入購物中有無法用C幣兌換的商品，請重新確認。`')
      //- 故事卡僅開放給一般會員
      PopWarning(v-else-if='popBoxStatus.include === `warnNotDoctor`' :textInfo='`抱歉！僅限一般會員。`')
      //- 健康促進任務
      PopWarning(v-else-if='popBoxStatus.include === `warnHealthComplete`' :textInfo='`每天只能完成 1 項任務 (隔天重置)。`')
      //- 故事卡僅開放給一般會員
      PopWarning(v-else-if='popBoxStatus.include === `warnEproPreviewMode`' :textInfo='`目前是預覽模式，無實際功能。`')
      //- 收費無購物車商品
      PopWarning(v-else-if='popBoxStatus.include === `warnNotCart`' :textInfo='`請先選購商品`')
      //- 收費無購物車商品
      PopWarning(v-else-if='popBoxStatus.include === `warnShopNoMix`' :textInfo='`抱歉！您已有選購的商品，訂閱服務/保健商品無法同時購買，請重新選擇。`')
      //- 副作用記錄已存在
      PopWarning(v-else-if='popBoxStatus.include === `warnRecordExist`' :textInfo='`抱歉！指定日期已有紀錄。`')
      //- 副作用記錄已存在
      PopWarning(v-else-if='popBoxStatus.include === `warnDateError`' :textInfo='`指定日期在未來，請重填。`')
      //- 發生錯誤
      PopWarning(v-else-if='popBoxStatus.include === `warnError`' :textInfo='`發生錯誤！`')
      //- 發生錯誤
      PopWarning(v-else-if='popBoxStatus.include === `warnVendorError`' :textInfo='`無權限，請通報服務單位`')
      //- Dr.Cell發生錯誤
      PopWarning(v-else-if='popBoxStatus.include === `warnDrcellError`' :textInfo='`Dr.Cell發生錯誤！請重試`')
      //- 發生錯誤
      PopWarning(v-else-if='popBoxStatus.include === `warnWebSocketError`' :textInfo='`已中斷Ai服務 :(`')
      //- 發生錯誤
      PopWarning(v-else-if='popBoxStatus.include === `warnEmptyEproError`' :textInfo='`尚有必填的項目未作答。`')
      //- 驗證碼錯誤
      PopWarning(v-else-if='popBoxStatus.include === `warnRedeemError`' :textInfo='`無效的兌換碼！`')
      //- 驗證碼錯誤
      PopWarning(v-else-if='popBoxStatus.include === `warnVerifyError`' :textInfo='`驗證碼錯誤！`')
      //- 重設密碼連結失效
      PopWarning(v-else-if='popBoxStatus.include === `warnResetPasswordInvalid`' :textInfo='`重設密碼連結已失效！`')
      //- 重設密碼區塊
      PopForgetPassword(v-else-if='popBoxStatus.include === `forgetPassword`')
      //- 非信箱註冊設定信箱
      PopSetEmail(v-else-if='popBoxStatus.include === `setEmail`')
      //- 重設密碼區塊
      PopSendVerify(v-else-if='popBoxStatus.include === `sendVerify`')
      //- 商務訂閱方案發送提案、聯繫顧問
      PopBusinessRequest(v-else-if='popBusinessRequest.active' :purpose='popBusinessRequest.purpose')
      //- 祝福牆已送出
      //- PopBlessIsSend(v-else-if='popBoxStatus.include === `blessSend`')
      //- 快捷選單
      PopStartup(v-else-if='popStartupStatus.active')
      //- 刪除故事卡區塊
      //- PopDeleteResume(v-else-if='popDeleteResumeStatus.active' :userId='popDeleteResumeStatus.userId' :card='popDeleteResumeStatus.card')
      //- 送出祝福牆
      //- PopCreateBless(v-else-if='popBlessStatus.active' :resumeId='popBlessStatus.resumeId')
      //- 發起提問 :resumeId='popBlessStatus.resumeId'
      PopControlQuestion(v-else-if='popQuestionStatus.active' :qid='popQuestionStatus.qid' :feature='popQuestionStatus.feature')
      //- 刪除祝福牆區塊
      //- PopDeleteBless(v-else-if='popDeleteBlessStatus.active' :resumeId='popDeleteBlessStatus.resumeId')
      //- 刪除討論板留言區塊
      //- PopDeleteReply(v-else-if='popDeleteReplyStatus.active' :aaId='popDeleteReplyStatus.aaId' :qId='popDeleteReplyStatus.qId' :remindId='popDeleteReplyStatus.remindId')
      //- 刪除討論板問題
      //- PopDeleteAsk(v-else-if='popDeleteAskStatus.active' :qid='popDeleteAskStatus.qid')
      //- 刪除翻譯紀錄
      PopDeleteTranslation(v-else-if='popDeleteTranslationStatus.active' :id='popDeleteTranslationStatus.id' :forId='popDeleteTranslationStatus.forId')
      //- 刪除紀錄
      PopDeleteEpro(v-else-if='popDeleteEproStatus.active' :id='popDeleteEproStatus.id' )
      //- 醫師推薦名單
      PopAgreeList(v-else-if='popAgreeListStatus.active' :type='popAgreeListStatus.type' :id='popAgreeListStatus.id')
      //- 顧問醫師名單
      PopChatAdditionalVendor(v-else-if='popChatAdditionalStatus.active' :detail='popChatAdditionalStatus.detail')
      //- 顧問醫師名單
      PopHealthCheckList(v-else-if='popCheckListStatus.active' :detail='popCheckListStatus.detail')
      //- 文章點擊Youtube播放框
      PopYoutube(v-else-if='popYoutubeStatus.active' :link='popYoutubeStatus.link')
      //- 課程單元播放框
      PopCoursePlayer(v-else-if='popCourseStatus.active' :cid='popCourseStatus.cid' :uid='popCourseStatus.uid')
      //- 文章點擊Youtube播放框
      PopImgZoom(v-else-if='popZoomStatus.active' :src='popZoomStatus.src')
      //- QRcode 圖片框
      PopQRcode(v-else-if='popQRcodeStatus.active' :link='popQRcodeStatus.link')
      //- 團隊組織 Feature列表
      PopTeamFeature(v-else-if='popTeamFeatureStatus.active' :features='popTeamFeatureStatus.features')
      //- 癌友求助 Filter狀態
      PopHelpFilter(v-else-if='popHelpFilterStatus.active' :query='popHelpFilterStatus.query')
      //- 最新消息
      PopReadNews(v-else-if='popLatestNewsStatus.active' :loadData='popLatestNewsStatus.list')
      //- 新改版提示
      PopHowToSetPwa(v-else-if='popShowTutorialStatus.include === `pwa`')
      //- 新改版提示
      PopHowToGetPoint(v-else-if='popShowTutorialStatus.include === `point`')
      //- 上傳血壓血糖範例
      PopHowToUploadBlood(v-else-if='popShowTutorialStatus.include === `blood-upload`')
      //- 如何使用副作用紀錄
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `se`' :feature='`se`')
      //- 如何使用報告解說
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `translator`' :feature='`translator`')
      //- 如何使用咨詢室
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `consult`' :feature='`consult`')
      //- 如何使用QA問答庫
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `ai`' :feature='`ai`')
      //- 如何升級VIP會員/收費
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `shop`' :feature='`shop`')
      //- 如何使用改善建議與通知
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `notify`' :feature='`notify`')
      //- 如何使用癌友故事卡
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `resume`' :feature='`resume`')
      //- 如何使用癌症討論板
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `qa`' :feature='`qa`')
      //- 如何使用精選文章
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `scoop`' :feature='`scoop`')
      //- 如何使用公益資源
      PopHowToUseFeature(v-else-if='popShowTutorialStatus.include === `help`' :feature='`help`')
      //- 諮詢顧問介紹
      PopConsultVendor(v-else-if='popVendorProfile.active' :detail='popVendorProfile.detail')
      //- 抗癌金句
      PopGoldKnowledge(v-else-if='popShowTutorialStatus.include === `gold-knowledge`')
      //- VIP訂閱到期
      PopSubscribeRequire(v-else-if='popShowTutorialStatus.include === `subscribe-vip`')
      //- 副作用改善建議
      //- PopRecordAdvise(v-else-if='popAdviseStatus.active' :alert='popAdviseStatus.alert' :behavior='popAdviseStatus.behavior')
      //- 藥品完整資訊
      PopDrugDetail(v-else-if='popDrugStatus.active' :detail='popDrugStatus.detail')
      //- 收費商品資訊
      //- PopShopStuffDetail(v-else-if='popShopStuffStatus.active' :detail='popShopStuffStatus.detail')
      //- 訂閱照護商品資訊
      //- PopShopBundleDetail(v-else-if='popShopBundleStatus.active' :detail='popShopBundleStatus.detail')
      //- 使用者檢舉
      PopUserReport(v-else-if='popReportStatus.active' :detail='popReportStatus.detail')
      //- 免費VIP訂閱
      PopFreeTrail(v-else-if='popFreeTrailStatus.active')
      //- Drcell翻譯結果
      PopTranslatorResult(v-else-if='popTranslatorStatus.active' :detail='popTranslatorStatus.detail')
      //- Drcell Analysis結果
      PopAnalysisResult(v-else-if='popAnalysisStatus.active' :detail='popAnalysisStatus.detail')
      //- Drcell Diet Recognize結果
      PopDietRecognizeResult(v-else-if='popDietRecognizeStatus.active' :detail='popDietRecognizeStatus.detail')
      //- 瀏覽單獨EPRO內容
      PopEproRecordDetail(v-else-if='popEproRecordDetail.active' :recordId='popEproRecordDetail.recordId')
      //- 瀏覽單獨血壓血糖數據
      PopChronicBloodDetail(v-else-if='popChronicBloodDetail.active' :detail='popChronicBloodDetail.detail')

</template>

<script>
import { mapGetters } from 'vuex';

import PopLoading from './PopLoading.vue';
import PopProgressLoading from './PopProgressLoading.vue';
import PopGlucosePressureUploader from './PopGlucosePressureUploader.vue';
import PopConfirm from './PopConfirm.vue';
import PopCheer from './PopCheer.vue';
import PopReadAgreement from './PopReadAgreement.vue';
import PopLogin from './PopLogin.vue';
import PopRelogin from './PopRelogin.vue';
import PopNeedVerify from './PopNeedVerify.vue';
import PopControlResume from './PopControlResume.vue';
import PopForgetPassword from './PopForgetPassword.vue';
import PopSetEmail from './PopSetEmail.vue';
import PopSendVerify from './PopSendVerify.vue';
import PopQRcode from './PopQRcode.vue';
import PopTeamFeature from './PopTeamFeature.vue';
import PopHelpFilter from './PopHelpFilter.vue';
import PopYoutube from './PopYoutube.vue';
import PopCoursePlayer from './PopCoursePlayer.vue';
import PopImgZoom from './PopImageZoom.vue';
import PopAvatarUploader from './PopAvatarUploader.vue';
import PopChatUploader from './PopChatUploader.vue';
import PopSpeechInputer from './PopSpeechInputer.vue';
import PopChatWizard from './PopChatWizard.vue';
import PopDrugDetail from './PopDrugDetail.vue';
// import PopShopStuffDetail from './PopShopStuffDetail.vue';
// import PopShopBundleDetail from './PopShopBundleDetail.vue';
import PopAgreeList from './PopAgreeList.vue';
import PopChatAdditionalVendor from './PopChatAdditionalVendor.vue';
import PopResumeExist from './PopResumeExist.vue';
import PopWarning from './PopWarning.vue';
import PopControlQuestion from './PopControlQuestion.vue';
// import PopDeleteResume from './PopDeleteResume.vue';
// import PopCreateBless from './PopCreateBless.vue';
// import PopDeleteBless from './PopDeleteBless.vue';
// import PopDeleteReply from './PopDeleteReply.vue';
// import PopDeleteAsk from './PopDeleteQuestion.vue';
// import PopBlessIsSend from './PopBlessIsSend.vue';
// import PopRecordAdvise from './PopRecordAdvise.vue';
import PopDeleteEpro from './PopDeleteEpro.vue';
import PopDeleteTranslation from './PopDeleteTranslation.vue';
import PopStartup from './PopStartup.vue';
import PopHowToSetPwa from './PopHowToSetPwa.vue';
import PopHowToGetPoint from './PopHowToGetPoint.vue';
import PopHowToUploadBlood from './PopHowToUploadBlood.vue';
import PopHowToUseFeature from './PopHowToUseFeature.vue';
import PopUserReport from './PopUserReport.vue';
import PopCreatePersonalData from './PopCreatePersonalData.vue';
import PopFreeTrail from './PopFreeTrail.vue';
import PopTranslatorResult from './PopTranslatorResult.vue';
import PopAnalysisResult from './PopAnalysisResult.vue';
import PopDietRecognizeResult from './PopDietRecognizeResult.vue';
import PopConsultVendor from './PopConsultVendor.vue';
import PopGoldKnowledge from './PopGoldKnowledge.vue';
import PopSubscribeRequire from './PopSubscribeRequire.vue';
import PopReadNews from './PopReadNews.vue';
import PopEproRecordDetail from './PopEproRecordDetail.vue';
import PopChronicBloodDetail from './PopChronicBloodDetail.vue';
import PopHealthCheckList from './PopHealthCheckList.vue';
import PopBusinessRequest from './PopBusinessRequest.vue';

export default {
  components: {
    PopLoading,
    PopProgressLoading,
    PopGlucosePressureUploader,
    PopConfirm,
    PopCheer,
    PopLogin,
    PopReadAgreement,
    PopRelogin,
    PopNeedVerify,
    PopControlResume,
    PopForgetPassword,
    PopSetEmail,
    PopSendVerify,
    PopQRcode,
    PopYoutube,
    PopCoursePlayer,
    PopImgZoom,
    PopAvatarUploader,
    PopChatUploader,
    PopSpeechInputer,
    PopChatWizard,
    PopDrugDetail,
    // PopShopBundleDetail,
    PopAgreeList,
    PopChatAdditionalVendor,
    PopResumeExist,
    PopWarning,
    PopControlQuestion,
    // PopDeleteResume,
    // PopCreateBless,
    // PopDeleteBless,
    // PopDeleteReply,
    // PopDeleteAsk,
    // PopBlessIsSend,
    // PopRecordAdvise,
    PopDeleteTranslation,
    PopDeleteEpro,
    PopStartup,
    PopUserReport,
    PopTeamFeature,
    PopHelpFilter,
    PopCreatePersonalData,
    PopFreeTrail,
    PopBusinessRequest,
    PopTranslatorResult,
    PopAnalysisResult,
    PopDietRecognizeResult,
    PopHowToUploadBlood,
    PopHowToSetPwa,
    PopHowToGetPoint,
    PopHowToUseFeature,
    PopConsultVendor,
    PopGoldKnowledge,
    PopSubscribeRequire,
    PopReadNews,
    PopEproRecordDetail,
    PopChronicBloodDetail,
    PopHealthCheckList,
  },

  // created() {
  //   document.body.classList.add('cc-overflow-hide');
  //   document.documentElement.style.overflow = 'hidden';
  // },

  // destroyed() {
  //   document.body.classList.remove('cc-overflow-hide');
  //   document.documentElement.style.overflow = 'unset';
  // },

  data() {
    return {
      updateKey: 1,
    };
  },

  // methods: {},

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      popBoxStatus: 'global/exportPopBoxStatus',
      popDrugStatus: 'global/exportPopDrugStatus',
      popProgressStatus: 'global/exportPopProgressStatus',
      popBloodUploadStatus: 'global/exportPopBloodUploadStatus',
      popYoutubeStatus: 'global/exportPopYoutubeStatus',
      popCourseStatus: 'global/exportPopCourseStatus',
      popZoomStatus: 'global/exportPopZoomStatus',
      popTeamFeatureStatus: 'global/exportPopTeamFeatureStatus',
      popHelpFilterStatus: 'global/exportPopHelpFilterStatus',
      popQRcodeStatus: 'global/exportPopQRcodeStatus',
      popAgreeListStatus: 'global/exportPopAgreeListStatus',
      popChatAdditionalStatus: 'global/exportPopChatAdditionalStatus',
      popShowTutorialStatus: 'global/exportPopShowTutorialStatus',
      popQuestionStatus: 'global/exportPopQuestionStatus',
      popDeleteTranslationStatus: 'global/exportPopDeleteTranslationStatus',
      popDeleteEproStatus: 'global/exportPopDeleteEproStatus',
      popReportStatus: 'global/exportPopReportStatus',
      popFreeTrailStatus: 'global/exportPopFreeTrailStatus',
      popBusinessRequest: 'global/exportPopBusinessRequest',
      popTranslatorStatus: 'global/exportPopTranslatorStatus',
      popAnalysisStatus: 'global/exportPopAnalysisStatus',
      popDietRecognizeStatus: 'global/exportPopDietRecognizeStatus',
      popLatestNewsStatus: 'global/exportPopLatestNewsStatus',
      popVendorProfile: 'global/exportPopVendorProfileStatus',
      popEproRecordDetail: 'global/exportPopEproRecordDetail',
      popChronicBloodDetail: 'global/exportPopChronicBloodDetail',
      popStartupStatus: 'global/exportPopStartupStatus',
      popCheckListStatus: 'global/exportPopCheckListBox',
    }),

    isLargeHeight() {
      const largeHeightComponents = [
        this.popCourseStatus,
        this.popTranslatorStatus,
        this.popAnalysisStatus,
        this.popDietRecognizeStatus,
        this.popEproRecordDetail,
        this.popStartupStatus,
        this.popChronicBloodDetail,
      ];
      return largeHeightComponents.some((component) => component.active);
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popBox.scss';
</style>
